<template>
  <div id="accessory" v-loading="loading">
    <el-row :span="24">
      <el-col :sm="24" :md="24" :lg="24">
        <div class="line">
          <span class="name">选择文件:</span>
          <el-upload
            v-auth="'/accessory/upload'"
            class="upload-demo"
            :action="fileObj.url"
            :before-upload="beforeUpload"
            :data="fileLoadData"
            :on-success="fileHandleSuccess"
            :on-error="fileError"
            :headers="reqData"
            :show-file-list="false"
          >
            <el-button size="small" type="primary">上传附件</el-button>
          </el-upload>
        </div>
      </el-col>
    </el-row>
    <el-row :span="24">
      <el-col :sm="24" :md="24" :lg="24">
        <div class="line">
          <span class="name">生成路径:</span>
          <el-input ref="copy" class="aaa" v-model="addFileUrl"></el-input>
          <el-button
            v-auth="'/accessory/copy'"
            size="small"
            type="primary"
            v-clipboard:copy="addFileUrl"
            v-clipboard:success="onCopy"
            v-clipboard:error="onError"
          >复制</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row :span="24">
      <el-col :sm="24" :md="24" :lg="24">
        <div class="line">
          <span class="name">图片路径:</span>
          <el-input ref="copy" class="aaa" v-model="addImgUrl"></el-input>
          <el-button
            v-auth="'/accessory/copy'"
            size="small"
            type="primary"
            v-clipboard:copy="addImgUrl"
            v-clipboard:success="onCopyImg"
            v-clipboard:error="onErrorImg"
          >复制</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fileLoadData: {},
      loading: false,
      addFileUrl: "",
      addImgUrl: "",
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile",
        url2: process.env.BASE_URL + "/question/importQuestionsByChapter"
      }
    };
  },
  created() {},
  methods: {
    beforeUpload(file) {
      this.loading = true;
    },
    fileError(response, file, fileList, $event) {
      this.$message.error("附件上传失败");
      this.loading = false;
    },
    fileHandleSuccess(response, file, fileList, $event) {
      this.loading = false;
      this.addFileUrl = response.data;
      this.addImgUrl = "<img src='" + response.data + "'>";
    },
    onCopy: function(e) {
      this.$message.success("内容已复制到剪切板！");
    },
    onError: function(e) {
      this.$message.error("抱歉，复制失败！");
    },
    onCopyImg: function(e) {
      this.$message.success("内容已复制到剪切板！");
    },
    onErrorImg: function(e) {
      this.$message.error("抱歉，复制失败！");
    }
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less">
#accessory {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 20px;
  .line {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;
  }
  .name {
    width: 80px;
    font-size: 14px;
    color: #333;
    white-space: nowrap;
  }
  .aaa {
    max-width: 500px;
    min-width: 200px;
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/accessory/index.vue